import React from 'react';
import Line1Icon from '@lt/components/icons-react/rebrand/BeachLine1';
import Line2Icon from '@lt/components/icons-react/rebrand/BeachLine2';
import Line3Icon from '@lt/components/icons-react/rebrand/BeachLine3';
import { i18n } from '@lt/localization';
import HotelFeature from '../HotelFeature';

import styles from './beachLineFeature.module.css';

const LABEL = i18n.t('hotelcard.facts.beach_line.label');
const ICONS = [Line1Icon, Line2Icon, Line3Icon] as const;

type BeachLineFeatureProps = {
  value: null | 1 | 2 | 3;
  isMobile: boolean;
};

const makeIcon = (line: 1 | 2 | 3) => {
  const IconComp = ICONS[line - 1];
  return (
    <div className={styles.iconContainer}>
      <IconComp />
    </div>
  );
};

const BeachLineFeature: React.FC<BeachLineFeatureProps> = ({
  value,
  isMobile,
}) =>
  value ? (
    <HotelFeature Label={LABEL} Icon={makeIcon(value)} isMobile={isMobile} />
  ) : null;

export default BeachLineFeature;
